import { defineComponent as _defineComponent } from 'vue'
import { onMounted, computed } from 'vue';
import { useVideoDebugStore } from '@/store/video-debug';
import type { ManifestRendition, ManifestAudioTrack } from '@/store/video-debug';
import { getDeviceCapabilitiesForDebug } from '@/utils/device';


export default /*@__PURE__*/_defineComponent({
  __name: 'OnScreenDebuggerVideoTab',
  setup(__props, { expose: __expose }) {
  __expose();

const store = useVideoDebugStore();

const sortedRenditions = computed(() => {
  const list = [...store.availableRenditions.value];
  list.sort((a, b) => (b.height ?? 0) - (a.height ?? 0));
  return list;
});

function formatBitrate(bps: number | undefined): string {
  if (bps == null) return '—';
  if (bps >= 1e6) return `${(bps / 1e6).toFixed(2)} Mbps`;
  if (bps >= 1e3) return `${(bps / 1e3).toFixed(1)} Kbps`;
  return `${bps} bps`;
}

function renditionLabel(r: ManifestRendition): string {
  const h = r.height;
  const br = r.bitrate;
  if (h != null && br != null) return `${h}p · ${formatBitrate(br)}`;
  if (h != null) return `${h}p`;
  if (br != null) return formatBitrate(br);
  return '—';
}

function audioTrackLabel(a: ManifestAudioTrack): string {
  if (a.label) return a.label;
  if (a.lang) return a.lang;
  return a.id ?? '—';
}

/** Replace JWT/token path segment and query string so URL is safe to display. */
function trimManifestUrlForDisplay(url: string): string {
  if (!url || typeof url !== 'string') return url;
  const match = url.match(/^(https?:\/\/[^/]+)\/[^/]+(\/.*?)(?:\?.*)?$/);
  if (match) return match[1] + '/...' + match[2];
  return url;
}

function resolutionText(info: { width?: number; height?: number }): string {
  const w = info.width;
  const h = info.height;
  if (w != null && h != null) return `${w}×${h}`;
  return '—';
}

onMounted(async () => {
  const caps = await getDeviceCapabilitiesForDebug();
  store.setDeviceCapabilities(caps);
});

const __returned__ = { store, sortedRenditions, formatBitrate, renditionLabel, audioTrackLabel, trimManifestUrlForDisplay, resolutionText }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})